app.mediator.registerModule(MODULE_NAME__PROJECT_PAGE, function (app) {

    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {
            this.$rootElem = $('.page-entry');
            if (!this.$rootElem.length) return;
            this.addDomListeners();
            this.addMediatorListeners();
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addDomListeners: function() {

            var scope = this;

            this.$rootElem.find('.social-share-button').click(function () {
                app.mediator.notify(EVENT_NAME__PROJECT_PAGE__SOCIAL_MEDIA_SHARE_BUTTON_CLICKED);
            });

            // Stop video on press of escape key.
            $(document).keyup(function (e) {
                var $focusedElement = $(':focus');
                var isChildOfVideoArea = !!$focusedElement.closest('.wrap-slideshow').length;
                if (e.keyCode == 27) {
                    if (typeof JdaVideoTools !== 'undefined') {
                        JdaVideoTools.embedManager.pauseAll();
                    }
                    if (isChildOfVideoArea) {
                        $('.jda-slideshow-pagination-item.active button').focus();
                    }
                }
            });
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addMediatorListeners: function () {
        }
		
        //==========================================================xdiv2====
        // Module
        //===================================================================

	};
});
